import 'babel-polyfill';
import 'bulma/css/bulma.min.css';
import './style';
import App from './components/app';

export default App;
